import { render, staticRenderFns } from "./WebmastersTable.vue?vue&type=template&id=b82c5582&scoped=true"
import script from "./WebmastersTable.vue?vue&type=script&lang=ts"
export * from "./WebmastersTable.vue?vue&type=script&lang=ts"
import style0 from "./WebmastersTable.vue?vue&type=style&index=0&id=b82c5582&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b82c5582",
  null
  
)

export default component.exports